<div id="barChart" class="chart-container"></div>